import { useEffect } from 'react'
import { MODEL_VIEWER_HOST } from '../../constants/constants'
const ZoomToMaterial = (props) => {

   const { viewerId, modelId, listData, currentStepIndex } = props

   useEffect(() => {
      const materialName = listData[currentStepIndex].materialId
      const frame = document.getElementById(viewerId)
      const action = { action: 'FOCUS_ON_MATERIAL', payload: { modelId, materialName } }
      frame.contentWindow.postMessage(action, MODEL_VIEWER_HOST)
   }, [viewerId, currentStepIndex, modelId, listData])


   return null
}
export default ZoomToMaterial